import React, { Component } from 'react'
import {connect} from 'react-redux'
import {Button,ButtonToolbar,FormControl,InputGroup,FormGroup,OverlayTrigger,Tooltip} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwsome from 'react-fontawesome'
import AutopartStore from 'stores/AutopartStore'
import WorkdocStore from 'stores/WorkdocStore'
import SWTWageItemListPopup from '../SWTWageItemListModal'
import SWTProgramPopup from '../SWTProgramModal'
import _ from 'lodash'
import $ from 'jquery'
import DNDRowItem from './DNDRowItem'


class SWTWageDataGrid extends Component {
  constructor(...props) {
    super(...props)
    
    this.state = {
      data:this.newEmptyRow(props.initNoOfRow,'first'),
      options:[],
      showPopup:false,
      showProgram:false,
      program:null,
      can_drag:false,
      darg_id:null
    }
    this.init = false
  }

  componentDidMount() {
    $('body').on('click', ()=> {
      $('.table-responsive').css( "overflow-x", "auto" );
      $('.table-responsive').css( "overflow-y", "" );
    });  
    $('body').on('keydown', ()=> {
      if ($('.tdTypeaHead > div.bootstrap-typeahead').children().length>1) {
        $('.table-responsive').css( "overflow-x", "initial" );
        $('.table-responsive').css( "overflow-y", "unset" );
      } else {
        $('.table-responsive').css( "overflow-x", "auto" );
        $('.table-responsive').css( "overflow-y", "" );
      }
    });
  }

  componentWillReceiveProps(newProps){
    if((newProps.show  && !this.init) || (this.init && newProps.show !== this.props.show)){
    //if(newProps.show  && !this.init){ //&& newProps.show !== this.props.show){
      // console.log('2.setWageList',newProps.wageList,newProps.show)
      this.setWageList(newProps.wageList)
      this.init = true
    }
  }

  getWageList(){
    let {data} = this.state
    return data.reduce((rresult,item)=>{
      if(item.detail!==''){
        rresult.push(item)
      }
      return rresult
    },[])
  }

  setWageList(wageList){
    // console.log('set wage',wageList)
    // let data = wageList.map((item,index)=>{
    //   let amount = item.price_per_unit * item.quantity
    //   return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemcode:item.itemcode,servicecode:item.servicecode,
    //     detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:amount,
    //     discountPercent:item.discount_percent,discountAmount:item.discount_amount}
    // })

    let data = wageList
    if(data.length<=this.props.initNoOfRow){
      data = data.concat(this.newEmptyRow(this.props.initNoOfRow-data.length))
    }
    data = data.map((item,index)=>{
      item.rowNo = (index+1).toString()
      return item
    })
    this.setState({data:data})
    
    //if(this.props.onChange!==undefined)
    //  this.props.onChange(data)
    
    return data
  }

  newEmptyRow(number,rowNo=''){
    //let {showQuantity}  = this.props.showQuantity
    //console.log('props',this.props)
    //let showQuantity = true
    if (rowNo==='first')
      rowNo = ''
    else {
      let {data} = this.state
      rowNo = (data.length+1).toString()
    }
    return new Array(number).fill(null).map((item,index)=>{
      return {bfId:'',rowNo:rowNo,itemcode:'',detail:'',quantity:'',pricePerUnit:'',amount:'',discountPercent:'',discountAmount:''}
    })
  }

  onCodeSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartProductCodeList(-1,query,function(result){
      // console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit,costPerUnit:item.cost_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,partFrom:''}
      })
      // console.log('options',options)
      that.setState({codeOptions:options})
    })
  }

  onSearch(index,query){
    let {data} = this.state
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadWageItemList(-1,query,function(result){
      // console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemcode,itemcode:item.itemcode,servicecode:item.servicecode,categoryName:item.category_name,detail:item.description,amount:item.price}
      })
      that.setState({options:options})
    })
    //data[index]['detail'] = query
    //data[index]['pricePerUnit'] = ''
    data[index]['discountPercent'] = ''
    data[index]['discountAmount'] = ''
    if(data[index]['quantity']==='')
      data[index]['quantity'] = 1
    
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onSearch2(query){

    let that = this
    let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadWageSuggest(query,function(result){
      // console.log(result)
      //that.setState({optins:result.data})
    })
    that.setState({optins:options})
  }

  // onPricePerUnitChange(index,e){
  //   let {data} = this.state
    
  //   let amount = e.target.value
  //   if(isNaN(amount)){
  //     data[index].pricePerUnit = ''
  //   }else{
  //     data[index].pricePerUnit = amount*1
  //   }
  //   data[index].amount = data[index].pricePerUnit*data[index].quantity

  //   console.log('row',index,e.target.value,data[index].amount,data[index].pricePerUnit,data[index].quantity)
  //   this.setState({data:data})
  // }

  // onQuantityChange(index,e){
  //   let {data} = this.state
  //   console.log('row',index,e)
  //   let amount = e.target.value
  //   if(isNaN(amount)){
  //     data[index].quantity = ''
  //   }else{
  //     data[index].quantity = amount
  //   }
  //   data[index].amount = data[index].pricePerUnit*data[index].quantity
  //   this.setState({data:data})
  // }

  onSearchKeyPress(index,field,target) {
    if(target.charCode===13){
      let {data} = this.state
      // console.log("code enter",data[index])    
      
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({loading:false})
      let servicecode = data[index][field];
      WorkdocStore.loadItemWageServiceCode(servicecode,(result)=>{
        // console.log(result)
        //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
        if(result.data.length>0){
          let item = result.data[0]        
          data[index].detail = item.description        
          data[index].servicecode = item.servicecode
          
          data[index].pricePerUnit = item.price
          data[index].quantity = 1
          data[index].amount  = item.price
          data[index].discountPercent  = ''
          data[index].discountAmount  = ''
          
          this.setState({loading:false,data:data})
          if(this.props.onChange!==undefined)
            this.props.onChange(data)
                        
        }else{
          this.setState({loading:false})
        }
      })      
    }
  }


  onTypeaheadChange(index,option){
     // console.log('onTypeaheadChange',index,option)

    let {data} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      if(typeof option[0].itemcode !=='undefined'){
        data[index].itemcode = option[0].itemcode  
        data[index].servicecode = option[0].servicecode
        data[index].amount = option[0].amount
        data[index].pricePerUnit = option[0].amount
        data[index].quantity = 1
        
      }else{
        //data[index].pricePerUnit = ''
        if(data[index].quantity==='')
          data[index].quantity = 1
      }
    }
    // else{
    //   data[index].detail = ''
    //   data[index].amount = ''
    //   data[index].itemcode = ''
    // }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onTypeaheadInputChange(index,query){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
      item.rowNo = (index+1).toString()
      return item
    })
    return itemlist
  }

  onRemoveRowClick(index){
    let {data} = this.state
    data.splice(index,1);
    data = this.sortRowIndex(data)
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onAddEmptyRowItemClick(number){
    let {data} = this.state

    let newRows = this.newEmptyRow(number)

    
    this.setState({data:data.concat(newRows)})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onSearchClick(){
    //this.refs.wageItemPopup.getWrappedInstance().openPopup();
    this.setState({showPopup:true})
  }

  onProgramClick(){
    // if (process.env.NODE_ENV === "development") {
      //this.refs.programPopup.getWrappedInstance().openPopup();
      this.setState({showProgram:true})  
    // }else{
    //   alert('กำลังพัฒนาให้ใส่โปรแกรมได้')
    // }
  }

  onProgramDeleteClick() {
    if (this.props.onProgramDeleteClick!==undefined)
      this.props.onProgramDeleteClick()
  }

  onItemSelect(newItem){
    //Finding Last row
    let {data} = this.state
    let foundItem = -1
    data.forEach((item,index)=>{
      if(item.detail==='' && foundItem===-1){
             
        foundItem = index
      }
    })

    let item = {}
    
    item.itemcode = newItem.itemcode
    item.servicecode = newItem.servicecode
    item.detail = newItem.description
    item.amount = newItem.price   
    item.pricePerUnit = newItem.price
    item.quantity = 1
    if(foundItem>=0) {
      item.rowNo = data[foundItem].rowNo
      data[foundItem] = item
    } else {
      item.rowNo = (data.length+1).toString()
      data.push(item)
    }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onProgramSelect(wageItem,partItem,program){
    let {data} = this.state
  
    data = []
    
    let rowNo = data.length
    let newItems = wageItem.map((item,index)=>{
      rowNo++
      return {bfId:'',rowNo:rowNo,itemcode:item.wage_itemnum,servicecode:(item.servicecode===undefined?'':item.servicecode),detail:item.detail,pricePerUnit:item.wage_cost,quantity:item.quantity,amount:item.wage_cost}  
    })
    data = data.concat(newItems)    
    if(data.length<=this.props.initNoOfRow){
      data = data.concat(this.newEmptyRow(this.props.initNoOfRow-data.length))
    }    
    this.setState({data:data,program:program})
    if(typeof this.props.onProgramChange !=='undefined')
      this.props.onProgramChange(wageItem,partItem,program)
  }

  summaryAmount(){
    let {data} = this.state
    let sum = 0;
     data.forEach((item,index)=>{
        sum += item.amount*1
    })
    sum = parseFloat(sum).toLocaleString(undefined, {minimumFractionDigits: 2})
    return (<span>{sum}</span>)
  }

  _renderMenuItemChildren(option, props, index) {
    if(option.amount>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.amount} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  renderServiceCode(item,index){
    if(this.props.showServiceCode){
      return (
        <td key={1}>
          <FormControl 
          value={item.servicecode} 
          onChange={this.onTextChange.bind(this,index,'servicecode')}
          onKeyPress={this.onSearchKeyPress.bind(this,index,'servicecode')}  
          />                  
        </td>
      )
    }else{
      return ('')
    }
  }

  renderQuantity(item,index){
    let {hidePriceOnDamage} = this.props
    if(this.props.showQuantity){
      if(hidePriceOnDamage){
        return (<td key={10001} className='text-right'>
                  <FormControl className='text-center ' 
                  value={item.quantity} 
                  onChange={this.onTextChange.bind(this,index,'quantity')}/>                  
                </td>)
      }
    return [
      <td key={10001} className='text-right'>
        <FormControl className='text-center ' 
        value={item.quantity} 
        onChange={this.onTextChange.bind(this,index,'quantity')}/>                  
      </td>,
      <td key={10002} className='text-right'>
        <FormControl className='text-right' 
        value={item.pricePerUnit} 
        onChange={this.onTextChange.bind(this,index,'pricePerUnit')}/>                  
      </td>
    ]
    }else if(this.props.showDiscount){
      return ('')
    }else{     
      if(hidePriceOnDamage){
        return ('')
      } 
      return (
        <td key={10001} className='text-right'>
          <FormControl className='text-right'  
          value={item.amount} 
          onChange={this.onTextChange.bind(this,index,'amount')}/>                  
        </td>
      )
    }
  }

  renderAmount(item){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showQuantity || this.props.showDiscount){
      return (
        <td key={6} className='text-right'>
          <FormControl className='text-right'  value={item.amount} />                  
        </td>
      )      
    }else{
      return ('')
    }
  }

  renderDiscountPercent(item,index){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showDiscount){
      return (
        <td key={4} className='text-right'>
          <FormGroup>
            <InputGroup>
              <FormControl 
                style={{borderTopRightRadius:'4px',borderBottomRightRadius:'4px'}}
                type="text" 
                className='text-center'
                value={item.discountPercent}
                onChange={this.onTextChange.bind(this,index,'discountPercent')}
              />
              <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit'}}>%</InputGroup.Addon>
            </InputGroup>
          </FormGroup>           
        </td>
    )
    }else{
      return ('')
    }
  }

  renderDiscountAmount(item,index){ 
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showDiscount){
      return (
        <td key={5} className='text-right'>
          <FormControl 
            className='text-right' 
            value={item.discountAmount}
            onChange={this.onTextChange.bind(this,index,'discountAmount')}
          />      
        </td>
    )
    }else{
      return ('')
    }
  }

  renderColDetail(index,item) {
    let {messages} = this.props
    let {options,can_drag,darg_id} = this.state
    let uniq = item.rowNo
    let hover = (
      <OverlayTrigger
          key={'right'}
          placement={'right'}
          overlay={
              <Tooltip id={'tooltip-right'}>
                Hold & darg to sort the Items
              </Tooltip>
          }
          >
          <div className='wrap-tool'>
            <div className='card-tool'><FontAwsome name='bars' /></div>
          </div>
      </OverlayTrigger>
    )
    return([
                <td 
                  key={0} 
                  className='text-center'
                  style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
                  onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
                  onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
                >
                  {can_drag&&darg_id===uniq?hover:index+1}
                </td>,
                this.renderServiceCode(item,index),
                <td key={2} className='tdTypeaHead'>
                  <AsyncTypeahead
                    allowNew={true}
                    multiple={false}
                    newSelectionPrefix={messages['Add New Item']+' : '}   
                    promptText={messages['Keypress For Searching']}           
                    searchText={messages['Searching']}
                    selected={[{detail:item.detail}]}
                    options={options}
                    labelKey="detail"
                    onSearch={this.onSearch.bind(this,index)}
                    onChange={this.onTypeaheadChange.bind(this,index)}
                    onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                    placeholder=""
                    renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
                  />                  
                </td>,
                this.renderQuantity(item,index),    
                this.renderDiscountPercent(item,index),
                this.renderDiscountAmount(item,index),
                this.renderAmount(item),                
                <td key={7}>
                  <Button bsStyle={'danger'} bsSize={'sm'} onClick={this.onRemoveRowClick.bind(this,index)}><FontAwsome name="trash"/></Button>
                </td>
    ])
  }

  renderRowData(){
    let {data,can_drag} = this.state
    return data.map((item,index)=> { 
      return <DNDRowItem 
        key={index} 
        id={item.rowNo}
        item={item}
        can_drag={can_drag}
        moveRow={this.onMoveRow.bind(this)}
        renderColDetail={this.renderColDetail.bind(this,index)}
      />  
    })
  }

  onMoveRow(id,afterId) {
    let {data} = this.state
    var rows = _.clone(data);
    var currentRow = _.filter(rows, function (r) { return r.rowNo === id; })[0];
    var afterRow = _.filter(rows, function (r) { return r.rowNo === afterId; })[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data = rows
    this.setState({data: data});
  }

  // getAmount(item,index) {
  //   let {data} = this.state
  //   let discount = 0
  //   let amount = 0
  //   let price = 0
  //   price = item.pricePerUnit * item.quantity
  //   if (item.discountAmount<=0||isNaN(item.discountAmount)===true||item.discountAmount==="") {
  //     discount = 0
  //   } else {
  //     discount = item.discountAmount
  //   }  
  //   amount = price - discount
  //   if (amount===0||isNaN(amount)===true||amount===""){
  //     item.amount = 0
  //   } else {
  //     item.amount = amount
  //   }  
  // }

  getDiscountAmount(data,index) {
    
    if (data[index]['discountPercent']<=0||isNaN(data[index]['discountPercent'])===true){
      data[index]['discountAmount'] = 0
    } else {
      let discount = 0
      let price = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (price / 100) * data[index]['discountPercent']
      if (discount%1 !== 0) {
        discount = discount.toFixed(2)
      }
      data[index]['discountAmount'] = discount
    }
    return data
  }

  getDiscountPercent(data,index) {
    
    if (data[index]['discountAmount']<=0||isNaN(data[index]['discountAmount'])===true){
      data[index]['discountPercent'] = 0
    } else {  
      let price = 0
      let discount = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (data[index]['discountAmount'] / price) * 100
      if (discount%1 !== 0) {
        discount = discount.toFixed(2)
      }
      data[index]['discountPercent'] = discount
    }  
    return data
  }

  onTextChange(index,field,e){
    let {data} = this.state
    data[index][field] = e.target.value
    if(field==='pricePerUnit' || field==='quantity'){
      data[index].amount = (data[index].quantity*1) * (data[index].pricePerUnit*1)
    }else if(field==='amount'){
      if(!this.props.showQuantity){
        data[index]['pricePerUnit'] = data[index][field]
      }
    } else if (field==='discountAmount') {
      data = this.getDiscountPercent(data,index)
    } else if (field==='discountPercent') {
      data = this.getDiscountAmount(data,index)
    } else if (field==='quantity'||field==='pricePerUnit') {
      if ((e.target.value<=0||isNaN(e.target.value)===true||e.target.value==="")||(data[index].quantity<=0||isNaN(data[index].quantity)===true||data[index].quantity==="")||(data[index].pricePerUnit<=0||isNaN(data[index].pricePerUnit)===true||data[index].pricePerUnit==="")){
        data = this.getMistakeAmount(data,index)
      } else {          
        data = this.getDiscountAmount(data,index)
      }    
    } 

    if(this.props.showDiscount){
        let discount = 0
        let amount = 0
        let price = 0
        price = data[index].pricePerUnit * data[index].quantity
        if (data[index].discountAmount<=0||isNaN(data[index].discountAmount)===true||data[index].discountAmount==="") {
          discount = 0
        } else {
          discount = data[index].discountAmount
        }  
        amount = price - discount
        if (amount===0||isNaN(amount)===true||amount===""){
          data[index].amount = 0
        } else {
          data[index].amount = amount
        }      
    }

    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
    
  }

  getMistakeAmount(data,index) {
    
    data[index]['discountAmount'] = 0
    data[index]['amount'] = 0
    return data
  }
  /*===*/
  renderColumnServiceCode(){
    let {messages} = this.props
    if(this.props.showServiceCode){
      return (
        <th style={{width:'110px'}} className='text-center'>{messages['ServiceCode']}</th>
      )
    }else{
      return (
        ''
      )
    }
  }


  renderColumnQuantity(){
    let {messages,hidePriceOnDamage} = this.props
    if(this.props.showQuantity){
      if(hidePriceOnDamage){
        return (<th key={1} style={{width:'70px'}} className='text-center'>{messages['Quantity']}</th>)
      }
      return [
        <th key={1} style={{width:'70px'}} className='text-center'>{messages['Quantity']}</th>,
        <th key={2} style={{width:'110px'}} className='text-center'>{messages['Price/Unit']}</th>,
      ]
    }else if(this.props.showDiscount){
      return ('')  
    }else{
      if(hidePriceOnDamage){
        return ('')
      }
      return (
        <th style={{width:'110px'}} className='text-center'>{messages['Price']}</th>
      )
    }
  }

  renderColumnAmount(){
    let {messages,hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showQuantity || this.props.showDiscount){
      return (
        <th style={{width:'110px'}} className='text-center'>{messages['Total']}</th>
      )
    }else{
      return ('')
    }
  }

  renderColumnDiscount(){
    let {messages,hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showDiscount){
      return [
        <th key={1} style={{width:'80px'}} className='text-center'>{messages['Discount %']}</th>,
        <th key={2} style={{width:'110px'}} className='text-center'>{messages['Discount']}</th>,
      ]
    }else{
      return ('')
    }
  }

  renderFooter(){
    let {hidePriceOnDamage,messages} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    let colSpan = this.props.showQuantity?4:2
    if(this.props.showDiscount){
      colSpan += 2
    }
    if(this.props.showServiceCode){
      colSpan += 1
    }
    return (
      <tfoot>
            <tr>
              <th colSpan={colSpan} className='text-right'>{messages['Total Wages']}</th>            
              <th className='text-right'>{this.summaryAmount()}</th>
              <th></th>              
            </tr>
          </tfoot>
    )
  }

  renderTable(){
    let {messages} = this.props
    
    return (
      <div className='table-responsive'>
        <table className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th style={{width:'50px'}}  className='text-center'>{messages['Number']}</th>
              {this.renderColumnServiceCode()}
              <th className='text-center'>{messages['Item']}</th>
              {this.renderColumnQuantity()}    
              {this.renderColumnDiscount()}           
              {this.renderColumnAmount()}               
              <th style={{width:'50px'}} className='text-center'>{messages['Delete']}</th>            
            </tr>          
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          {this.renderFooter()}
        </table>
      </div>  
    )
  }

  renderDocMenu(){
    return (
      <div className="margin box-tools pull-right">
        <div className="btn-group hide-when-done">
        <button type="button" className="btn btn-primary "><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</button>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <span className="caret"></span>
        <span className="sr-only">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu" role="menu">
        <li aria-disabled="true"><a href="#new_doc_quotation"><i className="fa  fa-file-text-o text-green"></i>ใบเสนอราคา</a></li>
        <li aria-disabled="true"><a href="#new_doc_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบแจ้งหนี้</a></li>
        <li aria-disabled="true"><a href="#new_doc_receipt"><i className="fa  fa-file-text-o text-green"></i>ใบเสร็จรับเงิน</a></li>
        <li aria-disabled="true"><a href="#new_doc_tax_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบกำกับภาษี</a></li>
        <li aria-disabled="true"><a href="#new_doc_cash_bill"><i className="fa  fa-file-text-o text-green"></i>บิลเงินสด</a></li>
        <li aria-disabled="true"><a href="#new_doc_export_stock"><i className="fa  fa-file-text-o text-green"></i>ใบเบิกคลังสินค้า</a></li>
        </ul>
        </div>
      </div>
    )
  }

  render() {
    let {showPopup,showProgram} = this.state
    let {showProgramButton,messages} = this.props
    
    return (
      <div >
       
          {this.renderTable()}
          <ButtonToolbar style={{display:'inline-block'}}>
            <Button bsStyle={null} className='bg-olive'           
              onClick={this.onAddEmptyRowItemClick.bind(this,1)}
            >
              + {messages['Add Item']}
            </Button>
            <Button bsStyle={null} className='bg-olive' 
              onClick={this.onAddEmptyRowItemClick.bind(this,10)}
            >
              + {messages['Add 10 Item']}
            </Button>
            <Button bsStyle={'primary'} 
              onClick={this.onSearchClick.bind(this)}
            >
              <FontAwsome name='search'/>&nbsp;{messages['Search Wages']}
            </Button>
            <Button bsStyle={'warning'} style={{display:(showProgramButton)?'block':'none'}} 
              onClick={this.onProgramClick.bind(this)}
            >
              <FontAwsome name='book'/>&nbsp;{messages['Select Program']}
            </Button>
            <Button bsStyle={'danger'} style={{display:(showProgramButton)?'block':'none'}} 
              onClick={this.onProgramDeleteClick.bind(this)}
            >
              <FontAwsome name='trash'/>&nbsp;ลบโปรแกรม
            </Button>
          </ButtonToolbar>
        
        <SWTWageItemListPopup ref={'wageItemPopup'} show={showPopup} onSelect={this.onItemSelect.bind(this)} onHide={()=>{this.setState({showPopup:false})}}/>
        <SWTProgramPopup ref={'programPopup'} show={showProgram} 
        workNo={this.props.workNo}
        onSelect={this.onProgramSelect.bind(this)} 
        onHide={()=>{this.setState({showProgram:false})}}/>
      </div>
    )
  }
}

SWTWageDataGrid.defaultProps = {
  showServiceCode : false,
  show:false,
  initNoOfRow:10,
  hidePriceOnDamage:false,
  workNo:''
}

export default SWTWageDataGrid = connect(
  (state) => ({messages: state.message.view.workdoc.SWTWageDataGrid}),null,null,{withRef:true}
)(SWTWageDataGrid);


// WEBPACK FOOTER //
// ./src/view/workdoc/fast/SWTWageDataGrid.js